import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-errors" id="module-storage-errors"></a>
    <h1 {...{
      "id": "requireuxpstorageerrors--errors"
    }}>{`require('uxp').storage.errors : `}<inlineCode parentName="h1">{`Errors`}</inlineCode></h1>
    <a name="module-storage-errors-abstractmethodinvocationerror" id="module-storage-errors-abstractmethodinvocationerror"></a>
    <h2 {...{
      "id": "abstractmethodinvocationerror"
    }}>{`AbstractMethodInvocationError`}</h2>
    <p>{`Attempted to invoke an abstract method.`}</p>
    <a name="module-storage-errors-providermismatcherror" id="module-storage-errors-providermismatcherror"></a>
    <h2 {...{
      "id": "providermismatcherror"
    }}>{`ProviderMismatchError`}</h2>
    <p>{`Attempted to execute a command that required the providers of all
entries to match.`}</p>
    <a name="module-storage-errors-entryisnotanentryerror" id="module-storage-errors-entryisnotanentryerror"></a>
    <h2 {...{
      "id": "entryisnotanentryerror"
    }}>{`EntryIsNotAnEntryError`}</h2>
    <p>{`The object passed as an entry is not actually an `}<inlineCode parentName="p">{`Entry`}</inlineCode>{`.`}</p>
    <a name="module-storage-errors-entryisnotafoldererror" id="module-storage-errors-entryisnotafoldererror"></a>
    <h2 {...{
      "id": "entryisnotafoldererror"
    }}>{`EntryIsNotAFolderError`}</h2>
    <p>{`The entry is not a folder, but was expected to be a folder.`}</p>
    <a name="module-storage-errors-entryisnotafileerror" id="module-storage-errors-entryisnotafileerror"></a>
    <h2 {...{
      "id": "entryisnotafileerror"
    }}>{`EntryIsNotAFileError`}</h2>
    <p>{`The entry is not a file, but was expected to be.`}</p>
    <a name="module-storage-errors-notafilesystemerror" id="module-storage-errors-notafilesystemerror"></a>
    <h2 {...{
      "id": "notafilesystemerror"
    }}>{`NotAFileSystemError`}</h2>
    <p>{`The instance was expected to be a file system, but wasn't.`}</p>
    <a name="module-storage-errors-outofspaceerror" id="module-storage-errors-outofspaceerror"></a>
    <h2 {...{
      "id": "outofspaceerror"
    }}>{`OutOfSpaceError`}</h2>
    <p>{`The file system is out of space (or quota has been exceeded)`}</p>
    <a name="module-storage-errors-permissiondeniederror" id="module-storage-errors-permissiondeniederror"></a>
    <h2 {...{
      "id": "permissiondeniederror"
    }}>{`PermissionDeniedError`}</h2>
    <p>{`The file system revoked permission to complete the requested
action.`}</p>
    <a name="module-storage-errors-entryexistserror" id="module-storage-errors-entryexistserror"></a>
    <h2 {...{
      "id": "entryexistserror"
    }}>{`EntryExistsError`}</h2>
    <p>{`An attempt was made to overwrite an entry without indicating
that it was safe to do so via `}<inlineCode parentName="p">{`overwrite: true`}</inlineCode>{`.`}</p>
    <a name="module-storage-errors-fileisreadonlyerror" id="module-storage-errors-fileisreadonlyerror"></a>
    <h2 {...{
      "id": "fileisreadonlyerror"
    }}>{`FileIsReadOnlyError`}</h2>
    <p>{`An attempt was made to write to a file that was opened as
read-only.`}</p>
    <a name="module-storage-errors-domainnotsupportederror" id="module-storage-errors-domainnotsupportederror"></a>
    <h2 {...{
      "id": "domainnotsupportederror"
    }}>{`DomainNotSupportedError`}</h2>
    <p>{`Domain is not supported by the current FileSystemProvider
instance.`}</p>
    <a name="module-storage-errors-invalidfilenameerror" id="module-storage-errors-invalidfilenameerror"></a>
    <h2 {...{
      "id": "invalidfilenameerror"
    }}>{`InvalidFileNameError`}</h2>
    <p>{`The file name contains invalid characters`}</p>
    <a name="module-storage-errors-invalidfileformaterror" id="module-storage-errors-invalidfileformaterror"></a>
    <h2 {...{
      "id": "invalidfileformaterror"
    }}>{`InvalidFileFormatError`}</h2>
    <p>{`Unsupported format type`}</p>
    <a name="module-storage-errors-datafileformatmismatcherror" id="module-storage-errors-datafileformatmismatcherror"></a>
    <h2 {...{
      "id": "datafileformatmismatcherror"
    }}>{`DataFileFormatMismatchError`}</h2>
    <p>{`Data and Format mismatch`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      